// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hcacK","skeleton":"styles_skeleton__HXLTg","header":"styles_header__5GYGW"};